export default "__VITE_ASSET__KqJYuoL8__"